var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-file',{attrs:{"accept":".csv","placeholder":_vm.placeHolderText || 'Select or Drop File Here...',"drop-placeholder":_vm.dropPlaceHolderText || 'Drop file here...'},on:{"change":_vm.loadTextFromFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }